import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.7071 5.2929L20.3639 10.9497C20.7545 11.3402 20.7545 11.9734 20.3639 12.3639L14.7071 18.0208C14.3166 18.4113 13.6834 18.4113 13.2929 18.0208C12.9023 17.6303 12.9023 16.9971 13.2929 16.6066L17.2426 12.6568H4C3.44772 12.6568 3 12.2091 3 11.6568C3 11.1045 3.44772 10.6568 4 10.6568H17.2426L13.2929 6.70711C12.9023 6.31658 12.9023 5.68342 13.2929 5.2929C13.6834 4.90237 14.3166 4.90237 14.7071 5.2929Z" })
});
export default SvgArrowRightLine;
